import { InferType, object, string } from 'yup'
import queryString from 'qs'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  filter: object()
    .shape({
      rescheduled_by: string().oneOf(['provider']).required(),
    })
    .required(),
})

export type Request = InferType<typeof Schema>

export type ReschedulingReasonType = {
  reschedulingReasonId: string
  code: number
  reason: string
  rescheduledBy: string
  userTypes: string[]
  useCredit: boolean
}

export type SuccessfulResponse = {
  data: ReschedulingReasonType[]
}

export const url = ({ filter }: Request) =>
  `/v1/rescheduling-reasons?${queryString.stringify({ filter }, { indices: false })}`
